// components/ReviewNotesStep.tsx
import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Row, Col, Typography, Divider } from 'antd';
import { TextAreaField, RadioGroupField } from '@/components/Form';
import { PreLodgementChecklistFormValues } from '../types/preLodgementChecklist';

const { Title, Text } = Typography;

type Props = {
  control: Control<PreLodgementChecklistFormValues>;
  error: FieldErrors<PreLodgementChecklistFormValues>;
};

const YES_NO = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const ReviewNotesStep: React.FC<Props> = ({ control, error }) => {
  return (
    <div>
      <Title level={5} style={{ marginBottom: 4, marginTop: 0 }}>
        Additional Details
      </Title>
      <Text type="secondary">
        Anything else you'd like us to know before we review your assessment?
      </Text>

      <Divider style={{ margin: '12px 0 20px' }} />

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <TextAreaField
            formDirection="row"
            label="Is there anything else we should know or you would like answered?"
            name="additionalQuestions"
            control={control}
            placeholder="Share any questions or context..."
            error={error?.additionalQuestions?.message ?? ''}
          />
        </Col>

        <Col xs={24} md={12}>
          <RadioGroupField
            label="Would you like a free mortgage review?"
            name="wantsMortgageReview"
            control={control}
            options={YES_NO}
            error={error?.wantsMortgageReview?.message}
          />
        </Col>
      </Row>
    </div>
  );
};
